import React from 'react';
import { APP_STORE_URL, ANDROID_DOWNLOAD_URL } from './appLinks';

export function getAppRedirectUrl(userAgent) {
  const ua = userAgent || '';

  if (/android/i.test(ua)) {
    return ANDROID_DOWNLOAD_URL;
  }

  if (/iphone|ipad|ipod/i.test(ua)) {
    return APP_STORE_URL;
  }

  return '/';
}

function AppRedirect() {
  React.useEffect(() => {
    const url = getAppRedirectUrl(window.navigator.userAgent);
    window.location.replace(url);
  }, []);

  return null;
}

export default AppRedirect;
